import Cookies from 'universal-cookie/es6';
import { useHistory } from "react-router-dom";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems3
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina Creación – Se defienen los botones de la barra de navegación.
13/10/2021 Cristian Andres Pizo Mina -  Se agrego /Overtime
================================================================================ */
export default function MenuItems2() {
    let history = useHistory();
    const cookies = new Cookies();
    const items = [
        {
            label: 'Seguridad social',
            path: "/PILAHistoricSocialSecurity",
            index: 0
        },
        {
            label: 'Planillas',
            path: "/PILASheets",
            index: 1
        }

    ];
    return items
}